export class Error {
   // errorMessage:string;
   // code:string;

    constructor(public errorMessage:string, 
        public code:string){

    }
}